import { useTranslation } from "react-i18next";
import { DateField, InlineInputField, InlineSelect } from "./fields";
import { Form } from "react-bootstrap";
import { useWatch } from "react-hook-form";

const ScopeForm = ({ fieldName, control, isReadOnly = false, hideOperator = false }) => {
  const { t } = useTranslation(["programs"]);
  const operatorOptions = [
    { value: "before", label: t(($) => $.programs.scope.Before) },
    { value: "after", label: t(($) => $.programs.scope.After) },
    { value: "between", label: t(($) => $.programs.scope.Between) },
  ];
  const operator = useWatch({
    control,
    name: `${fieldName}.operator`,
  });

  return (
    <Form.Group>
      <div className="d-flex align-items-center flex-wrap">
        {!hideOperator && (
          <InlineSelect
            options={operatorOptions}
            fieldName={`${fieldName}.operator`}
            control={control}
            rules={{ required: true }}
            disabled={isReadOnly}
          />
        )}
        {!hideOperator && operator === "between" && (
          <>
            <div style={{ minWidth: "10rem" }}>
              <DateField
                fieldName={`${fieldName}.values.start_date`}
                control={control}
                rules={{ required: true }}
                placeholder={t(($) => $.programs.rule["start date"])}
                disabled={isReadOnly}
              />
            </div>
            <span className="mx-2">{t(($) => $.programs.scope.and)}</span>
            <div style={{ minWidth: "10rem" }}>
              <DateField
                fieldName={`${fieldName}.values.end_date`}
                control={control}
                rules={{ required: true }}
                placeholder={t(($) => $.programs.rule["end date"])}
                disabled={isReadOnly}
              />
            </div>
          </>
        )}
        {(hideOperator || operator !== "between") && (
          <>
            <InlineInputField
              width={"7rem"}
              fieldName={`${fieldName}.values.days`}
              control={control}
              rules={{ required: true }}
              format={"number"}
              isDisabled={isReadOnly}
            />
            <span className="mx-2">{t(($) => $.programs.scope.days)}</span>
          </>
        )}
      </div>
    </Form.Group>
  );
};

export default ScopeForm;
